enum Pages {
  CenterRegionDashboard,
  CenterDashboard,
  ShopRegionDashboard,
  ShopDashboard,
  StationRegionDashboard,
  StationDashboard,
  InsightsPage,
  DocumentPage,
}

export default Pages;
